module.exports = __webpack_public_path__ + "img/ap206.7ed0ad36.jpg";